import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';

import { UserService } from '../services/user/user.service';

@Injectable()
export class AuthenticatedGuard implements CanActivate, OnDestroy {
    private _subrelease : Subject<void> = new Subject<void>();

    private _isAuthenticated: boolean;
    private _currentRole: string;

    constructor(private userService : UserService) {
        this._isAuthenticated = false; // Default to not authenticated.

        this.userService.UserSubject
            .pipe(takeUntil(this._subrelease))
            .subscribe(user => {
                this._isAuthenticated = user && (user.AuthToken != null && user.AuthToken != '');
                this._currentRole = (user != null && user.CurrentRole ? user.CurrentRole.toLowerCase() : null);
            }
        );
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // At a minimum, only allow access if we have a valid authtoken stored for the current user.
        let isAuth = this._isAuthenticated;

        // If there is optional data present, particularly the 'roles' array, we must also check to ensure that the current role of the user allows for this state
        // to be reached.
        if (route.data != null && route.data['roles'] != null && route.data['roles'].length > 0) {
            if (this._currentRole == null) return false; // If we have limited roles, but no current role established, that is an automatic failure.

            let roles : string[] = route.data['roles'];

            let matched = roles.find((rolename: string) => {
                if (rolename == 'all' || rolename.toLowerCase() == this._currentRole) return true;
            });
            
            return (matched != null);
        }

        return this._isAuthenticated;
    }

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }
}



// WEBPACK FOOTER //
// ./src/routes/routing-guard.ts